import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants';
import dataModel from '../../models/DataModel';
import activityLogServices from '../../services/activityLogServices';

export default class EventHistoriesCollection extends AOCollection {
  /**
   * @param {object} filter - has the following properties:
   *  - searchString (string)
   *  - sortField (string)
   *  - ascending (boolean)
   *  - activityTypeId (string)
   *  - activitySubTypeId (string)
   *  - startDate (string)
   *  - endDate (string)
   */
  constructor(perPage, filter, userId, companyId, recordDescriptor) {
    super({
      name: ReduxConstants.EVENT_HISTORIES,
      collectionType: ReduxConstants.EVENT_HISTORY,
      perPage,
      filter,
      userId,
      companyId,
      recordDescriptor,
    });
  }

  static build(perPage, filter, userId, companyId, recordDescriptor) {
    const collection = new EventHistoriesCollection(perPage, filter, userId, companyId || localStorage.current_company_id, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(pageOverride, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      else this.page++;

      const { searchString, sortField, ascending, activityTypeId, activitySubTypeId, startDate, endDate } = this._filter;
      let serviceCall = activityLogServices.getEventHistories.bind(this, searchString, sortField, ascending, activityTypeId, activitySubTypeId, startDate, endDate, this.page, this.perPage, options.recordDescriptor);

      let newCollection = await this._fetchData(serviceCall, options, true);
      return newCollection;
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let collection = this.findCollection();

      let page = null;
      let perPage = null;
      
      // Get everything we already got
      if (shouldPaginate) {
        page = 1;
        if (collection && collection.perPage) {
          perPage = Math.max(this.perPage, collection.ids.length);
        }
      }

      const { searchString, sortField, ascending, activityTypeId, activitySubTypeId, startDate, endDate } = this._filter;
      let serviceCall = activityLogServices.getEventHistories.bind(this, searchString, sortField, ascending, activityTypeId, activitySubTypeId, startDate, endDate,
        page, perPage, options.recordDescriptor);

      let newCollection = await this._fetchData(serviceCall, options);
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/EventHistoriesCollection.js